export default __webpack_public_path__ + "static/media/vf3.cbe4dace.jpg";